import { AppState } from "../../../redux-configuration/AppState";

export const loadLocalCodeLoadingSelector = (appState: AppState): boolean => appState.registration.loadLocalCode.loading
export const loadLocalCodeErrorSelector = (appState: AppState): string | undefined => appState.registration.loadLocalCode.error
export const localCodeSelector = (appState: AppState): string | undefined => appState.registration.loadLocalCode.code
